import { createContext, useState, ReactNode, useContext } from "react";

interface SignatureContextType {
  signature: string;
  setSignature: (signature: string) => void;
}

const SignatureContext = createContext<SignatureContextType | undefined>(undefined);

export const SignatureProvider = ({ children }: { children: ReactNode }) => {
  const [signature, setSignature] = useState<string>("");

  return (
    <SignatureContext.Provider value={{ signature, setSignature }}>
      {children}
    </SignatureContext.Provider>
  );
};

export const useSignature = () => {
  const context = useContext(SignatureContext);
  if (context === undefined) {
    throw new Error("useSignature must be used within a SignatureProvider");
  }
  return context;
};
